<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a dp sensor" (click)="create()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- records_checked Column -->
            <ng-container matColumnDef="records_checked">
                <th mat-header-cell *matHeaderCellDef> Records checked? </th>
                <td mat-cell *matCellDef="let element"> {{element.records_check_text}} </td>
            </ng-container>

            <!-- remark Column -->
            <ng-container matColumnDef="remark">
                <th mat-header-cell *matHeaderCellDef> Remark </th>
                <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailDpSensor(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>
